<!-- Page header -->
<div class="page-head">
  <div class="page-head-main">
    <h1 class="page-title">
      Edit Portfolio
      @if (portfolio && portfolio.id && portfolio.isPrivate()) {
        <span class="pill pill-muted">Private</span>
      }
      @if (
        portfolio &&
        portfolio.id &&
        portfolio.isPublic() &&
        !portfolio.is_tutorial
      ) {
        <span class="pill pill-ready">Public</span>
      }
      @if (portfolio && portfolio.id && portfolio.isShared()) {
        <span class="pill pill-ready">Shared</span>
      }
      @if (portfolio && portfolio.id && portfolio.is_tutorial) {
        <span class="pill pill-ready">Tutorial</span>
      }
    </h1>
  </div>
  <div class="d-flex align-items-center" style="gap: 8px">
    <button [matMenuTriggerFor]="shareMenu" class="btn btn-ghost">
      Share
    </button>
    <mat-menu #shareMenu="matMenu" [overlapTrigger]="false" class="filter-menu">
      @if (portfolio) {
        <div
          mat-menu-item
          [disabled]="portfolio && portfolio.isPublic()"
          (click)="onShareClick()"
        >
          @if (portfolio.isShared()) {
            <span>Share settings</span>
          }
          @if (!portfolio.isShared()) {
            <span>Share to users</span>
          }
        </div>
      }
      @if (
        currentUser && currentUser.canSharePublicly() && !portfolio.is_tutorial
      ) {
        <div mat-menu-item (click)="onPublicToggle()">
          {{ portfolio.isPublic() ? "Unshare from Public" : "Share to Public" }}
        </div>
      }
      <div mat-menu-item (click)="onTutorialToggle()">
        {{
          portfolio.is_tutorial ? "Unshare from Tutorial" : "Share to Tutorial"
        }}
      </div>
      @if (portfolio && portfolio.isShared()) {
        <div mat-menu-item (click)="onUnshareClick()">Unshare</div>
      }
    </mat-menu>
    <button
      class="btn btn-ghost"
      type="button"
      (click)="onHistoryBackClick()"
    >
      Discard changes
    </button>
    <button
      class="btn btn-primary"
      type="button"
      (click)="portfolio.needReload = true; onSavePortfolioClick(portfolio)"
    >
      Save portfolio
    </button>
  </div>
</div>

@if (!portfolio.isGenerated()) {
  <div>
    <!-- Portfolio settings -->
    <div class="card mb-3" id="edit-portfolio">
      <div class="card-body">
        @if (portfolio && portfolio.id) {
          <app-manual-portfolio-form
            [portfolio]="portfolio"
            [maxStartDate]="max_start_date"
            [filterLists]="filterLists"
            [selectedCurrencies]="selectedCurrencies"
            [selectedBenchmark]="portfolio.benchmark"
            (portfolioSave)="onSavePortfolioClick($event)"
            (weightChange)="onWeightTypeChange()"
            (startDateSet)="onStartDateSet()"
          >
          </app-manual-portfolio-form>
        }
      </div>
    </div>
    <!-- Asset selection — card is inside the drawer container so Material's
    drawer background does not override the card surface -->
    <mat-drawer-container class="sidenav-container" autosize>
      <mat-drawer
        (openedChange)="onOpenedChange($event)"
        #drawer
        mode="over"
        position="end"
        autoFocus="false"
        class="sidenav"
      >
        <div [hidden]="!(type === 'filters')">
          <app-asset-table-column-visibility-filter
            #stockFilters
            [columnVisibility]="columnVisibility"
            assetType="stock"
            [quantList]="quantList"
            [dynamicColumns]="dynamicColumns"
            (columnChanged)="onDynamicColumnChange($event)"
          >
          </app-asset-table-column-visibility-filter>
        </div>
        <div
          [hidden]="!(type !== 'filters' && drawlerData) || true"
          class="p-48 pe-0"
        >
          <mat-form-field class="example-full-width">
            <mat-label>Search</mat-label>
            <input
              matInput
              placeholder="Search for..."
              [(ngModel)]="drawlerData.searchText"
              name="searchText"
            />
          </mat-form-field>
          <div class="selection-container">
            <button
              type="button"
              mat-button
              color="primary"
              (click)="drawlerData.selectAll()"
            >
              Select all
            </button>
            <button
              type="button"
              mat-button
              color="primary"
              (click)="drawlerData.deselectAll()"
            >
              Deselect all
            </button>
          </div>
          <mat-label>Choose an option</mat-label>
          <ul>
            @for (
              item of drawlerData.list | search: drawlerData.searchText;
              track item
            ) {
              <li
                [hidden]="
                  item.hidden == true ||
                  (drawlerData.hideMarked && item.marked == true)
                "
              >
                <mat-checkbox
                  (change)="handleCheckboxUpdate(item.id)"
                  [checked]="
                    filters[drawlerData.name]
                      ? filters[drawlerData.name].includes(item.id.toString())
                      : false
                  "
                >
                  {{ item.name }}
                </mat-checkbox>
              </li>
            }
          </ul>
          <div class="selection-container bottom-buttons">
            <button
              type="button"
              mat-button
              color="primary"
              (click)="filterCompanies(); drawer.toggle()"
            >
              OK
            </button>
            <button
              type="button"
              mat-button
              color="primary"
              (click)="drawlerData.onPanelCloseOrCancel(); drawer.toggle()"
            >
              Cancel
            </button>
          </div>
        </div>
      </mat-drawer>
      <div class="card mb-3" id="asset-selection">
        <div class="card-body">
          <app-new-portfolio
            [currentTab]="4"
            [list]="list"
            [selected]="selected"
            [filterLists]="filterLists"
            [meta]="meta"
            [portfolio]="portfolio"
            [portfolioList]="portfolioList"
            [selectedPortfolioIds]="selectedPortfolioIds"
            [portfolioMeta]="portfolioMeta"
            (getFilters)="getFiltersIn($event)"
            (fetchCompanies)="fetchCompaniesIn($event)"
            (itemSelect)="onCompanySelect($event)"
            (selectAll)="onSelectAll($event)"
            (pageEvent)="onPageEvent($event)"
            (cartClick)="onPortfolioCartClick()"
            (startDateChange)="onMaxStartDateChange($event)"
            (fileUploaded)="onFileUploaded($event)"
            (selectedSortingChanged)="changeSelectedSorting($event)"
            (fetchPortfolios)="fetchPortfoliosIn($event)"
            (portfolioPageEvent)="onPortfolioPageEvent($event)"
          >
          </app-new-portfolio>
        </div>
      </div>
    </mat-drawer-container>
  </div>
}
